/* Native linked-product fragments need the same initWidget lifecycle as Okendo's
 * official dynamic-rendering example. The app embed still owns its scripts,
 * settings, styles and review grouping; this bridge never installs the app.
 */
if (!customElements.get('lunya-okendo')) {
  class LunyaOkendo extends HTMLElement {
    constructor() {
      super();
      this.initialized = new WeakSet();
      this.onReady = this.initialize.bind(this);
    }

    connectedCallback() {
      document.addEventListener('oke-script-loaded', this.onReady);
      this.initialize();
    }

    disconnectedCallback() {
      document.removeEventListener('oke-script-loaded', this.onReady);
    }

    initialize() {
      if (!this.isConnected || typeof window.okeWidgetApi?.initWidget !== 'function') return;
      this.querySelectorAll('[data-oke-star-rating], [data-oke-widget], [data-oke-reviews-widget]').forEach(node => {
        if (this.initialized.has(node)) return;
        this.initialized.add(node);
        const failed = () => {
          this.initialized.delete(node);
          // Leave pre-rendered review content readable, and leave commerce alone.
          console.warn('Okendo widget could not initialize.');
        };
        try {
          const result = window.okeWidgetApi.initWidget(node);
          if (result?.catch) result.catch(failed);
        } catch { failed(); }
      });
    }
  }
  customElements.define('lunya-okendo', LunyaOkendo);
}
